import { Component, effect, ElementRef, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { StepperModule } from 'primeng/stepper';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FooterComponent } from '../../auctions/footer/footer.component';
import { HeaderComponent } from '../../auctions/header/header.component';
import { SelectModule } from 'primeng/select';
import { IItemDonationRequest } from '../../../models/IItemDonationRequest';
import { ItemDonationService } from '../../../services/donations/item-donation.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CustomValidators } from '../../../shared/validators/custom-validators';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { AuthService, LOGIN_TYPE_BID_INLINE, LOGIN_TYPE_REGISTER } from '../../../services/authentication/auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { SignInComponent } from '../../authentication/sign-in/sign-in.component';
import { IItemDonationResponse } from '../../../models/IItemDonationResponse';
import { ApiService } from '../../../services/api.service';
import { ICountry } from '../../../models/ICountry';
import { IState } from '../../../models/IState';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastMessageService } from '../../../services/toast-message/toast-message.service';
import { IItemDomationConfigDTO } from '../../../models/IItemDomationConfigDTO';
import { ProgressSpinner } from "primeng/progressspinner";
import { ThemeService } from '../../../services/theme.service';
import { faUser } from '@fortawesome/free-solid-svg-icons'


@Component({
  selector: 'app-items-donation',
  imports: [StepperModule, ButtonModule,
    RadioButtonModule,
    NgFor,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    FooterComponent,
    HeaderComponent,
    SelectModule,
    ButtonModule,
    InputNumberModule,
    FontAwesomeModule,
    NgClass,
    RouterModule,
    SignInComponent, 
    ProgressSpinner,
  FontAwesomeModule],
  templateUrl: './items-donation.component.html',
  styleUrl: './items-donation.component.scss'
})
export class ItemsDonationComponent implements OnInit {

  donorInfoForm: FormGroup;
  itemInfoForm: FormGroup;
  deliveryForm: FormGroup;

  // File 

  faUser= faUser;

  selectedFile: File | null = null;
  selecteDonordFile: File | null = null;
  imagesTarget: { src: string; name: string; size: string; file: File }[] = [];
  donorImageTarget: { src: string; name: string; size: string; file: File } | null = null;
  donorImage: File | null = null;
  itemImageName: string | null = null;
  donorImageName: string | null = null;

  private itemDonationService = inject(ItemDonationService);
  private apiService = inject(ApiService);
  private themeService = inject(ThemeService);
  @Input() id!: number;

  newItemId!: number;

  labelState!: string;
  labelPostalCode!: string;
  placeHolderState!: string;
  defaultCountry!: string;
  userName: string | null = null;
  userEmail: string | null = null;


  homePageSignal = this.apiService.homePageSignal;
  auctionConfigSignal = this.apiService.auctionConfigSignal;

  authSubscription!: Subscription;
  private readonly authService = inject(AuthService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly messageService = inject(ToastMessageService);

  itemDomationConfig = signal<IItemDomationConfigDTO | null>(null);

  isShowingLoginIframe = signal(false);
  loginUrl = signal('');
  isAuthenticated = this.oidcSecurityService.authenticated;
  loginPage = LOGIN_TYPE_BID_INLINE;

  donorTypeOptions = [
    { label: 'I am the donor', value: "donor" },
    { label: 'I am submitting items on behalf of a donor', value: "submitter" }
  ];

  donorTypeCompany = [
    { label: 'Individual', value: "individual" },
    { label: 'Company', value: "company" },
  ];

  deliveryOptions = [
    { label: 'ORG', value: 'ORG' },
    { label: 'PICKUP', value: 'PICKUP' },
    { label: 'BIDDER', value: 'BIDDER' },
    { label: 'DIGITAL', value: 'DIGITAL' }
  ];

  selectedDonorType: string = '';

  countries: ICountry[] = [];
  states: IState[] = [];

  //clean file input
  @ViewChild('donorFileInput') donorFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('itemfileInput') itemfileInput!: ElementRef<HTMLInputElement>;

  constructor(private fb: FormBuilder, private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
    this.donorInfoForm = this.fb.group({
      donorType: ['donor', [CustomValidators.required('Donor Type')]],
      donorTypeCompany: ['company', [CustomValidators.required('Donor Type')]],
      donorName: ['', [CustomValidators.required('Donor Name')]],
      donorImage: [''],
      website: [''],
      firstName: ['', [CustomValidators.required('First Name')]],
      lastName: ['', [CustomValidators.required('Last Name')]],
      phone: ['', [CustomValidators.required('Mobile Phone Number'), CustomValidators.numeric('Mobile Phone Number')]],
      email: ['', [CustomValidators.required('Email'), CustomValidators.email()]],
      address1: ['', [CustomValidators.required('Address')]],
      address2: [''],
      country: ['', CustomValidators.required],
      zip: ['', [CustomValidators.required('ZIP Code'), CustomValidators.zipCodeValidator('country')]],
      state: ['', [CustomValidators.required(''), CustomValidators.atLeastOneLetter('Region')]],
      city: ['', [CustomValidators.required('City')]],
    });

    this.itemInfoForm = this.fb.group({
      itemName: ['', [CustomValidators.required('Item Name')]],
      quantity: ['1', [CustomValidators.required('Quantity')]],
      itemDescription: ['', [CustomValidators.required('Item Description')]],
      specialNote: [''],
      estimatedValue: ['', [CustomValidators.required('Estimated Value'), CustomValidators.numeric('Estimated Value'), CustomValidators.greaterThanZero('Estimated Value')]],
      itemImage: ['']
    });

    this.deliveryForm = this.fb.group({
      delivery: ['ORG'],
      additionalInfo: ['']
    });

    effect(() => {
      const countries = this.apiService.countrySignal();
      if (countries)
        // console.log('countries', countries);
        this.countries = countries;

      const states = this.apiService.stateSignal();
      if (states && states.length > 0) {
        this.states = states;
        // this.creditCardInfoForm.get('state')?.setValue(this.states[0].abbreviation);
      } else {
        this.states = [];
        this.donorInfoForm.get('state')?.setValue('');
      }
    });

  }

  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {

        this.themeService.setPreset('bfg'); 
        this.themeService.customizeAuctionTheme(this.id!);


      if (!this.apiService.homePageSignal()) {
        const endpoint = 'auctions';
        this.apiService.getAuctionHomePageData(endpoint, this.id!);
        localStorage.setItem('homePageData', JSON.stringify(this.apiService.homePageSignal()));
      }

      if (!this.auctionConfigSignal()) {
      this.apiService.getAuctionConfig(this.id ?? 0).subscribe();
    }

      
    }



    this.donorInfoForm.reset();
    this.donorInfoForm.patchValue({
      donorType: 'donor',
      donorTypeCompany: 'company'
    });
    this.itemInfoForm.reset();
    this.itemInfoForm.patchValue({
      quantity: 1
    });
    this.deliveryForm.reset();
    this.deliveryForm.patchValue({
      delivery: 'ORG'
    });

    this.onCountries();

    if (this.homePageSignal()) {
      this.defaultCountry = this.homePageSignal()!.orgCountryCode;
    }

    // console.log(this.defaultCountry)
    this.onCountryEvent();
    this.onDonorNameEvent();

    this.onSuscriptionLogin();

    this.getItemDonationConfig();

  }
  onSuscriptionLogin() {
    this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
      if (isAuth) {
        this.oidcSecurityService.getUserData().subscribe(result => {
          if (result) {
            this.userName = result.name;
            this.userEmail = result.email;
            if (this.donorInfoForm.get('donorType')?.value === 'donor') {
              this.donorInfoForm.get('donorName')?.setValue(this.userName);
              this.donorInfoForm.get('email')?.setValue(result.email);
            } else {
              this.donorInfoForm.get('donorName')?.setValue('');
            }
          }
        });
      }
    });
  }

  onDonorNameEvent() {
    this.donorInfoForm.get('donorType')?.valueChanges.subscribe(donor => {
      if (donor === 'donor') {
        this.donorInfoForm.get('donorName')?.setValue(this.userName);
        this.donorInfoForm.get('email')?.setValue(this.userEmail);
      } else {
        this.donorInfoForm.get('donorName')?.setValue('');
        this.donorInfoForm.get('email')?.setValue('');
      }
    });
  }

  onCountryEvent() {
    this.donorInfoForm.get('country')?.setValue(this.defaultCountry);
    this.onLabelState(this.defaultCountry);
    this.onStates(this.defaultCountry);

    if (this.defaultCountry === 'US') {
      this.labelPostalCode = 'Zip Code'
    } else {
      this.labelPostalCode = 'Postal Code'

    }

    //country select event
    this.donorInfoForm.get('country')?.valueChanges.subscribe(country => {
      this.onLabelState(country);
      this.onStates(country);

      // Reset fields and clear validators 
      this.donorInfoForm.get('state')?.clearValidators();
      this.donorInfoForm.get('zipCode')?.clearValidators();
      this.donorInfoForm.get('state')?.reset();
      this.donorInfoForm.get('zipCode')?.reset();


      this.donorInfoForm.get('state')?.setValidators([
        CustomValidators.required(this.labelState),
        CustomValidators.atLeastOneLetter(this.labelState)
      ]);
      this.donorInfoForm.get('state')?.updateValueAndValidity();


      this.labelPostalCode = country === 'US' ? 'Zip Code' : 'Postal Code';

      this.donorInfoForm.get('zipCode')?.setValidators([
        CustomValidators.required(this.labelPostalCode),
        CustomValidators.zipCodeValidator(this.labelPostalCode)
      ]);
      this.donorInfoForm.get('zipCode')?.updateValueAndValidity();
    });

  }

  onLabelState(country: string) {
    switch (country) {
      case 'US':
      case 'AU':
        this.labelState = 'State'
        this.placeHolderState = 'Select State'
        break;
      case 'CA':
        this.labelState = 'Province'
        this.placeHolderState = 'Select Province'
        break;
      default:
        this.labelState = 'Region'
        break;
    }
  }

  activeStep = 0;
  activateCallback!: (index: number) => void;


  goToSecondStep(activateCallback: Function): void {
    // console.log('Form valid?', this.donorInfoForm.valid);
    // console.log('Form value:', this.donorInfoForm.value);
    // console.log('Form errors:', this.donorInfoForm.errors);
    // console.log('Controls:', this.donorInfoForm.controls);
    if (this.donorInfoForm.valid) {
      activateCallback(2);
    } else {
      this.donorInfoForm.markAllAsTouched();
    }
  }

  goToThirdStep(activateCallback: Function): void {
    if (this.itemInfoForm.valid) {
      activateCallback(3);
    } else {
      this.itemInfoForm.markAllAsTouched();
    }
  }

  getFieldError(form: FormGroup, field: string): string | null {
    const control = form.get(field);
    if (control && control.errors && (control.dirty || control.touched)) {
      const firstErrorKey = Object.keys(control.errors)[0];
      return control.errors[firstErrorKey];
    }
    return null;
  }

  onFileSelected(event: Event) {
    // console.log('Hi')

    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files?.[0] || null;
    this.itemImageName = this.selectedFile?.name ?? null;

    if (!this.selectedFile) {
      this.resetItemImageField();
      return;
    }

    const isValidSize = this.selectedFile.size <= 1 * 1024 * 1024;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    const isValidType = allowedTypes.includes(this.selectedFile.type);

    if (!isValidSize || !isValidType) {
      const control = this.itemInfoForm.get('itemImage');
      control?.setErrors({
        ...(isValidSize ? {} : { fileSize: 'Image must be smaller than 1 MB.' }),
        ...(isValidType ? {} : { fileType: 'Image must be one of JPG, PNG, or GIF types.' })
      });
      // control?.markAsTouched();
      // this.imagesTarget = [];
      this.selectedFile = null;

      if (this.itemfileInput?.nativeElement) {
        this.itemfileInput.nativeElement.value = '';
      }
      return;
    }

    //display images
    if (this.selectedFile) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagesTarget.push({
          src: reader.result as string,
          name: this.selectedFile!.name,
          size: (this.selectedFile!.size / 1024).toFixed(3) + ' KB',
          file: this.selectedFile!
        });
        if (this.itemfileInput?.nativeElement) {
          this.itemfileInput.nativeElement.value = '';
        }

        // this.clearImageControls();
      };
      reader.readAsDataURL(this.selectedFile);
    }

  }


  private resetItemImageField(): void {
    const control = this.itemInfoForm.get('itemImage');
    this.imagesTarget = [];
    this.selectedFile = null;
    control?.setValue(null);
    control?.setErrors(null);
  }


  onFileDonorImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] || null;

    if (!file) {
      this.resetImageField();
      return;
    }

    const clonedFile = file;

    const isValidSize = clonedFile.size <= 1 * 1024 * 1024;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    const isValidType = allowedTypes.includes(clonedFile.type);

    if (!isValidSize || !isValidType) {
      const control = this.donorInfoForm.get('donorImage');
      control?.setErrors({
        ...(isValidSize ? {} : { fileSize: 'Image must be smaller than 1 MB.' }),
        ...(isValidType ? {} : { fileType: 'Image must be one of JPG, PNG, or GIF types.' })
      });
      control?.markAsTouched();
      this.donorImageTarget = null;
      this.donorImage = null;

      this.donorFileInput.nativeElement.value = '';

      return;
    }
    this.donorImage = clonedFile;
    const reader = new FileReader();
    reader.onload = () => {
      this.donorImageTarget = {
        src: reader.result as string,
        name: clonedFile.name,
        size: (clonedFile.size / 1024).toFixed(3) + ' KB',
        file: clonedFile
      };

      this.donorFileInput.nativeElement.value = '';
    };
    reader.readAsDataURL(clonedFile);

  }

  private resetImageField(): void {
    const control = this.donorInfoForm.get('donorImage');
    this.donorImageTarget = null;
    this.donorImage = null;
    control?.setValue(null);
    control?.setErrors(null);
  }

  onCountries() {
    if (typeof window !== 'undefined') {
      this.apiService.getCountries().subscribe();
    }
  }

  onStates(countrySelected: string) {
    if (typeof window !== 'undefined') {
      this.apiService.getStates(countrySelected).subscribe();
    }
  }

  removeImage(imageRemove: any) {
    this.imagesTarget = this.imagesTarget.filter(img => img !== imageRemove);
  }

  removeDonorImage(): void {
    this.donorImageTarget = null;
    this.donorImage = null;
    this.donorImageName = null;
  }

  showLoginIframe() {
    // console.log('here');
    this.getLoginUrl();
  }

  getLoginUrl() {
    let urlHandler = (url: string) => {
      // console.log(url)
      this.loginUrl.set(url);
      this.isShowingLoginIframe.set(true);
    }
    let messageCallback = () => {
      this.isShowingLoginIframe.set(false);
    }
    this.authService.login(urlHandler, messageCallback, false, 0);
  }

    protected openRegisterModal() {
      this.authService.openLoginModal(LOGIN_TYPE_REGISTER, function () { } ,this.id,  () => {}, '', { hideSuccessButton: true });
    }

    afterRegister(): void {
      this.messageService.success('Registered successfully!');
    }

  onSubmitAll() {

    const formDonor = this.donorInfoForm.value;
    const formItem = this.itemInfoForm.value;
    const deliveryForm = this.deliveryForm.value;

    const donorType = this.donorInfoForm.get('donorType')?.value;
    const donorTypeCompany = this.donorInfoForm.get('donorTypeCompany')?.value;

    const itemDonation: IItemDonationRequest = {
      submitterIsDonor: donorType === 'donor',
      isCompany: donorTypeCompany === 'company',
      donorName: formDonor.donorName,
      donorWebsite: formDonor.website,
      contactFirstName: formDonor.firstName,
      contactLastName: formDonor.lastName,
      contactPhone: formDonor.phone,
      contactEmail: formDonor.email,
      contactAddress1: formDonor.address1,
      contactAddress2: formDonor.address1,
      contactCountry: formDonor.country,
      contactPostalCode: formDonor.zip,
      contactCity: formDonor.city,
      contactRegion: formDonor.state,
      itemQuantity: formItem.quantity,
      itemName: formItem.itemName,
      itemDescription: formItem.itemDescription,
      itemSpecialNote: formItem.specialNote,
      itemEstimatedValue: formItem.estimatedValue,
      deliveryType: deliveryForm.delivery,
      additionalInfo: deliveryForm.additionalInfo,
    };

    const itemImages: File[] = this.imagesTarget.map(image => image.file);

    // console.log('Donor image', this.donorImage);
    // console.log('itemImages', itemImages);

    this.itemDonationService.postItemDonation(itemDonation, this.id, this.donorImage, itemImages).subscribe({
      next: res => {
        // console.log('Item donation succesfull', res)

        // const newItem: IItemDonationResponse = JSON.parse(JSON.stringify(res));
        const newItem: IItemDonationResponse = {
          name: res.name,
          quantity: res.quantity,
          value: res.value,
          description: res.description,
          specialNote: res.specialNote,
          donatedBy: res.donatedBy,
          contactEmail: res.contactEmail,
          images: res.images ?? []
        };

        // console.log(newItem, 'newItem')
        const auctionId = this.id;

        this.router.navigate(['/item-donation-success'], {
          state: { newItem: newItem, auctionId }
        });

      },
      error: (err) => {
        let errorMsg = 'Unknown error';

        if (typeof err.error === 'string') {
          try {
            const parsed = JSON.parse(err.error);
            errorMsg = parsed.message || errorMsg;
          } catch {
            errorMsg = err.error;
          }
        } else if (err.error && err.error.errorMessage) {
          errorMsg = err.error.errorMessage;
        }

        this.messageService.error(errorMsg || 'Unknown error');
      }
    })
  }

  goBack() {
    window.history.back();
  }

  getItemDonationConfig() {
    this.itemDonationService.getItemDonationConfig(this.id).subscribe((data) => {
      this.itemDomationConfig.set(data);
    });
  }

 
}
